module.exports = __webpack_public_path__ + "img/regi_guide_4-3-1.78b2576b.png";